let slickDefaults = require('../slick-default/slick-default');
let debounce = require('../../modules/debounce');
require('./products-slider.less');

let size = require('../../modules/size');

jQuery(function($) {
    function setProductsShowcaseSlider() {
        var defaultOptions = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: size.desktop,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: size.tabletBig,
                    settings: { slidesToShow: 1 }
                }
            ]
        });

        $('.js-products-showcase-slider').each(function() {
            var $psSlider = $(this);

            if (!$psSlider.hasClass('slick-initialized')) {
                $psSlider.slick(
                    $.extend({}, defaultOptions, {
                        slidesToShow: 3,
                        responsive: [
                            {
                                breakpoint: size.desktop,
                                settings: { slidesToShow: 2 }
                            },
                            {
                                breakpoint: size.tabletBig,
                                settings: { slidesToShow: 1, dots: false }
                            },
                            {
                                breakpoint: size.tablet,
                                settings: { slidesToShow: 2, dots: true }
                            },
                            {
                                breakpoint: size.mobileBig,
                                settings: { slidesToShow: 1, dots: true }
                            }
                        ]
                    })
                );
            }
        });

        $('.js-products-slider-full').each(function() {
            var $psSlider = $(this);

            if (window.innerWidth < size.tablet) {
                if ($psSlider.hasClass('slick-initialized')) $psSlider.slick('unslick');
            } else {
                if (!$psSlider.hasClass('slick-initialized')) {
                    $psSlider.slick(
                        $.extend({}, defaultOptions, {
                            slidesToShow: 5,
                            responsive: [
                                {
                                    breakpoint: size.desktop,
                                    settings: { slidesToShow: 4 }
                                },
                                {
                                    breakpoint: size.tabletBig,
                                    settings: { slidesToShow: 3 }
                                }
                            ]
                        })
                    );
                }
            }
        });

        $('.js-products-slider-middle').each(function() {
            var $psSlider = $(this);

            if (window.innerWidth < size.tablet) {
                if ($psSlider.hasClass('slick-initialized')) $psSlider.slick('unslick');
            } else {
                if (!$psSlider.hasClass('slick-initialized')) {
                    $psSlider.slick(
                        $.extend({}, defaultOptions, {
                            slidesToShow: 3,
                            responsive: [
                                {
                                    breakpoint: size.desktop,
                                    settings: { slidesToShow: 4 }
                                },
                                {
                                    breakpoint: size.tabletBig,
                                    settings: { slidesToShow: 3 }
                                }
                            ]
                        })
                    );
                }
            }
        });
    }
    setProductsShowcaseSlider();
    debounce.setResizeDebounce(setProductsShowcaseSlider);
});



// WEBPACK FOOTER //
// ./blocks/products-slider/products-slider.js